import isEmpty from 'lodash/isEmpty';
import {
  LATITUDE_DECIMALS,
  LONGITUDE_DECIMALS,
  MAX_LATITUDE,
  MAX_LONGITUDE,
  MIN_LATITUDE,
  MIN_LONGITUDE,
} from './constants.ts';
import { countDecimals } from './countDecimals.ts';

export const validateCoordinates = (lat: number, lon: number, extraValues?: number[]): boolean =>
  !(
    Number.isNaN(lat) ||
    Number.isNaN(lon) ||
    lat > MAX_LATITUDE ||
    lat < MIN_LATITUDE ||
    lon > MAX_LONGITUDE ||
    lon < MIN_LONGITUDE ||
    !isEmpty(extraValues) ||
    countDecimals(lat) > LATITUDE_DECIMALS ||
    countDecimals(lon) > LONGITUDE_DECIMALS
  );
